import { simpleAction } from '../../utils';
import * as TYPES from './types';

/**
 * Request Wholesaler Subdomain
 * @type {function(type: string): {type: string, payload: any}}
 */
export const wholesalerSubdomainGetRequest = simpleAction(TYPES.WHOLESALER_SUBDOMAIN_GET_REQUEST);

/**
 * Request Wholesaler Subdomain Success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const wholesalerSubdomainGetSuccess = simpleAction(TYPES.WHOLESALER_SUBDOMAIN_GET_SUCCESS);
